<template>
  <div class="cards_">

    <div class="flex justify-end py-4">
      <!-- <button class="mini-button bg-primary-yellow" @click="showPaymentModal = true">
        Add Card
      </button> -->
    </div>

    <div class="flex flex-col gap-4" v-loading="loading">
      <div
        class="flex justify-between items-center"
        v-for="(card, index) in userCards"
        :key="index"
      >
        <div class="card_">
          <div class="flex gap-4">
            <span>
              <component
                width="25"
                :is="checkCardType(card.cardNumber)"
              ></component>
            </span>
            <p>
              {{ card.cardNumber.substring(0, 4) }}
                **** ****
              {{
                card.cardNumber.substring(
                  card.cardNumber.length - 4,
                  card.cardNumber.length
                )
              }}
            </p>
          </div>
          <div
            class="flex gap-2 cursor-pointer items-center"
            @click="removeCard(card.id)"
          >
            <img
              src="@/assets/images/icons/delete-icon.svg"
              class="text-sm w-5"
            />
            Remove
          </div>
        </div>
        <el-switch
          @change="setDefaultCard($event, card.id)"
          v-model="card.isDefault"
        />
      </div>

      <EmptyCard v-if="!userCards.length"  @addCardModal="showPaymentModal = true"/>
    </div>

    <!-- <div class="flex justify-end py-4">
      <button class="mini-button bg-primary-navy text-white">
        View Statement
      </button>
    </div> -->
    <AddCardModal
      @close-modal="showPaymentModal = false"
      :show-modal="showPaymentModal"
      @refresh="getUserCards"
    />
  </div>
</template>
<script>
import EmptyCard from "../Payments/EmptyCard.vue";
import MastercardIcon from "../../../assets/images/ondemand/MastercardIcon.vue";
import Visa from "../../../assets/images/ondemand/visa.vue";
import VerveIcon from "../../../assets/images/ondemand/VerveIcon.vue";
import AddCardModal from "./modals/AddCardModal.vue";

export default {
  data() {
    return {
      defaultCard: false,
      userCards: [],
      loading: false,
      showPaymentModal: false
    };
  },
  components: {
    EmptyCard,
    MastercardIcon,
    Visa,
    VerveIcon,
    AddCardModal,
  },
  mounted() {
    this.getUserCards();
  },
  methods: {
    checkCardType(val) {
      // Visa
      let visaRegex = /^4[0-9]{12}(?:[0-9]{3})?$/;
      if (visaRegex.test(val.replace(/\s+/g, ""))) {
        return "visa";
      }

      // Mastercard
      let mastercardRegex = /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;
      if (mastercardRegex.test(val.replace(/\s+/g, ""))) {
        return "mastercard-icon";
      }

      // Verve
      let verveRegex = /^(50[0-9]{14}|60[0-9]{14}|601[1-9][0-9]{11}|6011[0-9]{11}|65[0-9]{14}|30[0-9]{11})$/;
      if (verveRegex.test(val.replace(/\s+/g, ""))) {
        return "verve-icon";
      }
      return null;
    },
    setDefaultCard(val, input) {
      let payload = {
        cardId: input,
      };
      console.log(val, input);
      this.setcardAsDefault(payload);
      setTimeout(() => {
        this.getUserCards();
      }, 750);
    },
    addCard() {
      this.$router.push({
        name: "AccountStatement",
        params: { name: "add-card" },
      });
    },
    async removeCard(id) {
      try {
        await this.$_deleteCard(id);
        this.getUserCards();
      } catch (error) {
        this.handleError(error);
      }
    },
    async setcardAsDefault(val) {
      try {
        await this.$_setCardAsDefault({...val});
      } catch (error) {
        this.handleError(error);
      }
    },
    async getUserCards() {
      this.loading = true;
      try {
        const response = await this.$_getUsersCard();
        this.userCards = response.data.userCards;
        console.log("cards", this.userCards);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cards_ {
  background: #ffffff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  height: 70vh;
  gap: 1rem;
  @apply py-10;
}

.card_ {
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  display: flex;
  padding: 1rem;
  justify-content: space-between;
  width: 100%;
  margin-right: 1rem;
}
.mini-button {
  @apply px-5 py-3 rounded-sm;
}
</style>
